import { useMutation } from '@apollo/client';
import useEnableFastifyApi from './useEnableFastifyApi';
import { EXTEND_HOLD_SESSION } from '../mutations';
import restRequest from './restClient';
import useAsyncCall from './useAsyncCall';

function toGraphqlShape(bffResponse) {
  return { extendHoldSession: bffResponse };
}

export default function useExtendHoldSession(options) {
  const enableFastifyApi = useEnableFastifyApi();

  const graphqlResult = useMutation(EXTEND_HOLD_SESSION, options);
  const [restExecute, restState] = useAsyncCall(
    ({ variables: { input } = {} } = {}) =>
      restRequest({
        method: 'POST',
        path: '/air-api/v1/flights/extend-hold',
        body: input,
      }).then(toGraphqlShape),
    options,
  );

  if (enableFastifyApi) {
    return [restExecute, restState];
  }
  return graphqlResult;
}
